export default __webpack_public_path__ + "static/media/ev-charge-point-slow.7e218222.svg";